import { DesfazerToastDetalheView } from "./view-desfazer-toast-detalhe";
import type { DesfazerToastDetalheProps } from "./types-desfazer-toast-detalhe";

export function DesfazerToastDetalhe(props: DesfazerToastDetalheProps) {
  return <DesfazerToastDetalheView {...props} />;
}

export type * from "./types-desfazer-toast-detalhe";
